// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest,getRequestNobase } from '@/libs/axios';

// vip官网-网页取证-新增
export const _saveWebpage = (params) => {
    return postRequest('/evidenceWebpage/save', params)
}
// 分页获取
export const _getByPage = (params) => {
    return getRequest('/evidenceWebpage/getByPage', params)
}
// 更新取证标题
export const _updateTitle = (params) => {
    return postRequest('/evidenceWebpage/updateTitle', params)
}
// 网页取证核验接口
export const _getVerifyOperatio = (params) => {
    return getRequest('/verifyOperation/get', params)
}
// 重新取证
export const _getresave = (params) => {
    return postRequest('/evidenceWebpage/resave', params)
}
// 天平链核验数据
export const _getTianPing = (params) => {
    return postRequest('/getTianPing', params)
}
// 获取编码
export const _getBarcode = (params) => {
    return getRequest('/getGh', params)
}
//取证列表接口--渠道
export const _getEvidenceList = (params) => {
    return getRequest('/mars/evidence/list', params)
}
//下载证据包--渠道
export const _getPackageFile = (params) => {
    return postRequest('/mars/evidence/getPackageFile', params)
}
//获取BC文件--渠道
export const _getBcFile = (params) => {
    return postRequest('/mars/evidence/getBcFile', params)
}
//获取详情--渠道
export const _getEvidenceInfo = (params) => {
    return getRequest('/mars/evidence/get', params)
}
//获取证书--渠道
export const _getCertFile = (params) => {
    return postRequest('/mars/evidence/cert', params)
}

// 获取新的接口
export const _getEvidencePack = (params) => {
    return getRequest('/verifyOperation/evidencePack', params)
}

//通过证书编号获取证书核验信息  GET请求  
export const getVerifyInfoByCertCode = (params)=>{
    return getRequest('/cert/verify/getVerifyInfoByCertCode', params)
}
//通过hash值获取证书核验信息  GET请求   
export const getVerifyInfoByHash = (params)=>{
    return getRequest('/cert/verify/getVerifyInfoByHash', params)
}
export const _getCaptchaId = (params) => {
    return getRequestNobase('/hatch/common/captcha/init', params)
}
//通过hash值和订单号获取证书核验信息  GET请求
export const getVerifyInfoByHashAndOrderNo = (params)=>{
    return getRequest('/cert/verify/getVerifyInfoByHashAndOrderNo', params)
}
